export const nataliaJarek = {
    'meta': {
        'title': 'Psycholog, psychoterapeuta Natalia Jarek • Centrum COLLIGO',
        'description': 'Jestem psychologiem oraz psychoterapeutką w trakcie szkolenia w nurcie integracyjnym. Pracuje z dziećmi, młodzieżą oraz dorosłymi.'
    },
    'url': {
        'address': '/torun/zespol/psycholog-psychoterapeuta-natalia-jarek/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/natalia-jarek.webp',
            'width': 1100,
            'height': 1426,
            'alt': 'Psycholog, psychoterapeuta Natalia Jarek'
        }
    }
}